import type { Theme } from '@withjoy/joykit/theme';
import { useTheme } from '@withjoy/joykit/theme';
import type { StyleSystemProps } from '@withjoy/joykit/styled-system';
import { animationTransition } from '@shared/utils/animationTransition';

const borderColorFromState = ({ colors }: Theme, { $isDisabled, $isFocused, $isInvalid }: UseFocusBoxStylesArgs) => {
  if ($isDisabled) {
    return 'transparent';
  } else if ($isInvalid) {
    return colors.inputBorderError;
  } else if ($isFocused) {
    return colors.inputBorderFocused;
  }
  return 'transparent';
};

type UseFocusBoxStylesArgs = {
  $isDisabled: boolean;
  $isInvalid: boolean;
  $isFocused: boolean;
};

const baseStyles: StyleSystemProps = {
  position: 'relative',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'inputBorder',
  borderRadius: 3,
};

export const useFocusBoxStyles = (args: UseFocusBoxStylesArgs): StyleSystemProps => {
  const theme = useTheme();
  return {
    ...baseStyles,
    // Hover state
    _hover: {
      borderColor: args.$isDisabled ? undefined : 'mono6',
    },

    // Box shadow styles
    _after: {
      background: 'none',
      borderRadius: 3,
      boxShadow: `0px 0 0px 2px ${borderColorFromState(theme, args)}`,
      display: args.$isDisabled ? 'none' : 'block',
      content: '" "',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: 'none',
      transition: animationTransition('box-shadow'),
    },
  };
};
